var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      class: _vm.gameItemClass,
    },
    [
      _c(
        "div",
        {
          class: _vm.resultHeaderClass,
        },
        [
          _c(
            "div",
            {
              staticClass: "flex-width text-left",
            },
            [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex-width text-right",
            },
            [_vm._v("\n      " + _vm._s(_vm.roundRead) + "\n    ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.gameItemBodyClass,
        },
        [
          _c(
            "div",
            {
              staticClass: "flex-width text-center border-right",
            },
            [
              _c(
                "p",
                {
                  staticClass: "text-gray-500 px-0 py-0 my-0 mx-0 text-md",
                },
                [_vm._v("\n        สามตัวบน\n      ")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "text-dark px-0 py-0 my-0 mx-0 text-lg",
                },
                [_vm._v("\n        " + _vm._s(_vm.digitUpper) + "\n      ")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex-width text-center",
            },
            [
              _c(
                "p",
                {
                  staticClass: "text-gray-500 px-0 py-0 my-0 mx-0 text-md",
                },
                [_vm._v("\n        สองตัวล่าง\n      ")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "text-dark px-0 py-0 my-0 mx-0 text-lg",
                },
                [_vm._v("\n        " + _vm._s(_vm.digitUnder) + "\n      ")]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }